import { PipelineProspect } from 'providers/Pipeline';
import {
  ARC,
  CHECKOUT,
  CITY_INSPECTION,
  CITY_PERMITTING,
  DESIGN_APPROVAL,
  HOME_REVIEW,
  INSTALL_PREP,
  INSTALLATION,
  POWER_ON,
  UNKNOWN,
} from 'components/atoms/PipelineConsts';

const COMMISSION_TOTAL_STAGES = new Set([
  CHECKOUT,
  HOME_REVIEW,
  DESIGN_APPROVAL,
  CITY_PERMITTING,
  INSTALL_PREP,
  INSTALLATION,
  CITY_INSPECTION,
  POWER_ON,
  ARC,
  UNKNOWN,
]);

const stageShowsCommissionTotal = (stage: string): boolean =>
  COMMISSION_TOTAL_STAGES.has(stage);

const getProspectCommissionAmount = (
  prospect: PipelineProspect,
  useFusionCommission: boolean,
): number => {
  const amount = useFusionCommission
    ? prospect.fusionCommission
    : prospect.commission;
  return amount ?? 0;
};

type ColumnCommissionTotals = {
  total: number;
  fusionExpertTotal: number;
  fusionSpecialistTotal: number;
};

const sumColumnCommissions = (
  prospects: PipelineProspect[],
  useFusionCommission: boolean,
): ColumnCommissionTotals => {
  let total = 0;
  let fusionExpertTotal = 0;
  let fusionSpecialistTotal = 0;

  for (const prospect of prospects) {
    total += getProspectCommissionAmount(prospect, useFusionCommission);
    fusionExpertTotal += prospect.fusionCommission ?? 0;
    fusionSpecialistTotal += prospect.fusionCommissionSpecialist ?? 0;
  }

  return { total, fusionExpertTotal, fusionSpecialistTotal };
};

export {
  stageShowsCommissionTotal,
  getProspectCommissionAmount,
  sumColumnCommissions,
};
export type { ColumnCommissionTotals };
